import React from "react";
import { Alert, Button } from "@mui/material";

const PrivilegesSection = ({
  formData,
  privilegeOptions = [],
  isPrivilegesLoading = false,
  isPrivilegesError = false,
  privilegesErrorMessage = "",
  onRetryPrivileges = () => {},
  handlePrivilegeChange,
  handleSelectAllPrivileges,
  handleDeselectAllPrivileges,
  errors = {},
}) => {
  const isPrivilegeSelected = (privilegeValue) => {
    return (
      Array.isArray(formData.privileges) &&
      formData.privileges.includes(privilegeValue)
    );
  };

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Privileges</h3>
        <div className="space-x-2">
          <button
            type="button"
            onClick={handleSelectAllPrivileges}
            disabled={isPrivilegesLoading || isPrivilegesError}
            className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
          >
            Select All
          </button>
          <button
            type="button"
            onClick={handleDeselectAllPrivileges}
            disabled={isPrivilegesLoading || isPrivilegesError}
            className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
          >
            Deselect All
          </button>
        </div>
      </div>
      <div
        className={`grid grid-cols-2 gap-2 p-4 border rounded-lg ${
          errors.privileges ? "border-red-400" : ""
        }`}
      >
        {isPrivilegesLoading ? (
          <span className="text-sm text-gray-500">Loading privileges...</span>
        ) : isPrivilegesError ? (
          <div className="col-span-2">
            <Alert
              severity="error"
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={onRetryPrivileges}
                  sx={{ textTransform: "none", fontWeight: 600 }}
                >
                  Retry
                </Button>
              }
            >
              <div className="flex flex-col gap-1">
                <span className="font-medium">
                  We couldn&apos;t load the privilege list from the server.
                </span>
                <span className="text-sm">
                  {privilegesErrorMessage ||
                    "Privilege selection is temporarily unavailable. Please retry and try again."}
                </span>
              </div>
            </Alert>
          </div>
        ) : privilegeOptions.length > 0 ? (
          privilegeOptions.map((privilege) => (
            <label
              key={privilege.value}
              className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded"
            >
              <input
                type="checkbox"
                checked={isPrivilegeSelected(privilege.value)}
                onChange={() => handlePrivilegeChange(privilege.value)}
                className="rounded text-blue-600 focus:ring-blue-500"
              />
              <span className="text-sm">{privilege.label}</span>
            </label>
          ))
        ) : (
          <span className="text-sm text-gray-500">
            No privileges available.
          </span>
        )}
      </div>
      {errors.privileges ? (
        <p className="mt-2 text-sm text-red-600">{errors.privileges}</p>
      ) : null}
    </div>
  );
};

export default PrivilegesSection;
